<template>
  <div class="flex items-center">
    <input
     type="radio"
     class="focus:ring-curious-blue-500 h-4 w-4 text-curious-blue-600 border-gray-300 disabled:opacity-50"
     :class="inputClass"
     :id="id"
     :value="modelValue"
     :name="name"
     @input="($event: Event) => $emit('update:modelValue', ($event.target as HTMLInputElement).value)"
     :checked="selectedValue === modelValue"
     :disabled="disabled"
    >

    <label v-if="label" :for="id" class="ml-2 mb-0 block text-sm">
      {{label}}
    </label>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'





export default defineComponent({
  emits: ['update:modelValue'],
    props: {
      label: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      },
      modelValue:{
        type: [Boolean,Array,String,Object],
        default: false
      },
      name: {
        type: String,
        default: ''
      },
      selectedValue: {
        type: [Boolean,Array,String,Object],
        default: false
      },
      disabled: {
        type: [Boolean],
        default: false
      },
      inputClass: {
        type: String,
        default: ''
      }
    }
  })
</script>

<style scoped>

</style>
